// eslint-disable-next-line import/no-unresolved
import { route as originalRoute } from "ziggy-js";
// webつくのRoute情報(php artisan ziggy:generateで出力されるファイル)
import { Ziggy } from "@/shared/ziggy/ziggy";

/**
 * laravelのroute情報をJSで生成する
 * @param {string} name e.g api.user.popup
 * @param {object} params e.g { pageType: page_type }
 * @param {boolean} absolute 絶対パスで出力※ドメインに応じたRouteがあるので注意
 * @returns {string} e.g /api/popup/toppage/
 */
export default function route(name, params = {}, absolute = false) {
  return `${originalRoute(name, params, absolute, Ziggy)}/`; // トレイリングスラッシュ
}

/**
 * laravelのroute情報をJSで生成するクエリストリング付きの場合
 * @param {string} name e.g api.user.popup
 * @param {object} params e.g { pageType: page_type }
 * @param {boolean} absolute 絶対パスで出力※ドメインに応じたRouteがあるので注意
 * @returns {string} e.g /api/popup/toppage/?fair_id=1&xxx=yyy
 */
export function routeWithGetParameter(name, params = {}, absolute = false) {
  const url = route(name, [], absolute, Ziggy);
  const searchParams =
    new URLSearchParams(params).toString().length > 0
      ? `?${new URLSearchParams(params).toString()}`
      : "";

  return url + searchParams;
}
